"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _VerifyEmail = _interopRequireDefault(require("../screens/VerifyEmail"));
var validators = _interopRequireWildcard(require("../../../../services/input/validators"));
var _otpVerify = _interopRequireDefault(require("../../mutations/otpVerify"));
var _otpLogin = _interopRequireDefault(require("../../mutations/otpLogin"));
var _appleLink = _interopRequireDefault(require("../../mutations/appleLink"));
var _context = require("../../../../services/auth/context");
var _context2 = require("../../../../services/log/context");
var _events = require("../../consts/events");
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getErrorMessage = error => {
  switch (error) {
    case "INVALID_PASSCODE":
    case "INVALID_VERIFICATION":
      return (0, _reactIntl.defineMessage)({
        id: "account_v2.settings.invite_traveler.verify_email.error_wrong_code"
      });
    case "TOO_MANY_OTP_VERIFY_ATTEMPTS":
      return _errors.default.general;
    default:
      return null;
  }
};
const VerifyEmailScreen = _ref => {
  let {
    email,
    otpTransactionId,
    onChangeScreen,
    onOtpTransactionIdChange,
    otpFlow,
    onSignInFulfilled
  } = _ref;
  const [passcode, setPasscode] = React.useState("");
  const [error, setError] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [passcodeError, setPasscodeError] = React.useState(null);
  const [validatePasscode, setValidatePasscode] = React.useState(false);
  const {
    onCloseModal,
    onGetUserInfoAndLogin
  } = (0, _context.useAuth)();
  const {
    appleIdToken
  } = (0, _context.useAppleAuth)();
  const {
    log
  } = (0, _context2.useLog)();
  const isAppleLoginFlow = otpFlow === "appleLogin";
  function onPasscodeChange(e) {
    const target = e.target;
    setPasscode(target.value);
  }
  function validateInput() {
    const error = validators.required(passcode);
    setValidatePasscode(true);
    return Boolean(error);
  }
  function onPasscodeBlur() {
    setValidatePasscode(true);
  }
  React.useEffect(() => {
    if (validatePasscode) {
      setPasscodeError(validators.required(passcode));
    }
  }, [validatePasscode, passcode, passcodeError]);
  const getUserInfoAndLogIn = token => {
    return onGetUserInfoAndLogin({
      token
    }).then(() => {
      onSignInFulfilled();
      onCloseModal();
    });
  };
  function linkAppleAndLogIn(token, idToken) {
    (0, _appleLink.default)({
      idToken,
      token
    }).then(res => {
      if ("success" in res) {
        log(_events.APPLE_LINK_SUCCESS, {});
        return getUserInfoAndLogIn(token);
      }
      return Promise.resolve();
    }).catch(err => {
      log(_events.CRITICAL_LOGIN_ERROR, {
        error: String(err),
        operation: "appleLink"
      });
      setIsLoading(false);
      setError(_errors.default.general);
    });
  }
  function onContinueClick(e) {
    e.preventDefault();
    if (validateInput()) {
      return;
    }
    setIsLoading(true);
    if (otpTransactionId != null) {
      (0, _otpVerify.default)({
        transactionId: otpTransactionId,
        passcode
      }).then(res => {
        if ("token" in res) {
          log(_events.OTP_VERIFY_SUCCESS, {
            flow: otpFlow
          });
          const {
            token
          } = res;
          if (isAppleLoginFlow && typeof appleIdToken === "string") {
            linkAppleAndLogIn(token, appleIdToken);
            return;
          }
          getUserInfoAndLogIn(token).catch(err => {
            log(_events.CRITICAL_LOGIN_ERROR, {
              error: String(err),
              operation: "appleLink"
            });
            setIsLoading(false);
            setError(_errors.default.general);
          });
          return;
        }
        const errorMessage = getErrorMessage(res.error);
        setError(errorMessage);
        setIsLoading(false);
        log(_events.OTP_VERIFY_FAILED, {
          error: res.error
        });
      }).catch(err => {
        log(_events.OTP_VERIFY_FAILED, {
          error: String(err)
        });
        setIsLoading(false);
        setError(_errors.default.general);
      });
    }
    setError(null);
  }
  function onResendClick() {
    (0, _otpLogin.default)({
      email
    }).then(res => {
      if ("transactionId" in res) {
        log(_events.OTP_RESEND, {});
        onOtpTransactionIdChange(res.transactionId);
        return;
      }
      log(_events.OTP_LOGIN_FAILED, {
        operation: "otpLogin",
        error: res.error
      });
    }).catch(err => {
      setError(_errors.default.general);
      log(_events.CRITICAL_LOGIN_ERROR, {
        error: String(err),
        operation: "otpLogin"
      });
    });
  }
  function onBackClick() {
    if (otpFlow === "appleLogin") {
      onChangeScreen("linkBookings");
    } else if (otpFlow !== null && ["noPassword", "notVerified", "registration"].includes(otpFlow)) {
      onChangeScreen("emailLogin");
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerifyEmail.default, {
    onPasscodeChange: onPasscodeChange,
    passcode: passcode,
    onContinueClick: onContinueClick,
    onBackClick: onBackClick,
    onResendClick: onResendClick,
    onPasscodeBlur: onPasscodeBlur,
    passcodeError: passcodeError,
    isLoading: isLoading,
    error: error,
    email: email
  });
};
var _default = exports.default = VerifyEmailScreen;